import './titleLink.css'
export default function TitleLink(){
    return(
        <div className="title1" data-aos="fade-up" data-aos-easing="ease-out-cubic"
        data-aos-duration="2000">
            <h3>Browse Product Categories</h3>
        </div>
    )
}